module.exports = __webpack_public_path__ + "images/Plus_hover.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/Plus_hover.png
// module id = 391
// module chunks = 0 1